'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _glamorous = require('glamorous');
var _glamorous2 = _interopRequireDefault(_glamorous);
var _constants = require('../../constants');
var _checkboxWrapper = require('./checkbox-wrapper');
var _checkboxWrapper2 = _interopRequireDefault(_checkboxWrapper);
var _checkbox = require('./items/checkbox');
var _checkbox2 = _interopRequireDefault(_checkbox);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var Wrapper = (0, _glamorous2.default)('div')(function (_ref) {
  var singleColumn = _ref.singleColumn;
  return singleColumn ? {} : {
    display: 'flex',
    flexFlow: 'row wrap',
    justifyContent: 'space-between'
  };
});
var CheckboxStacked = function (_Component) {
  _inherits(CheckboxStacked, _Component);
  function CheckboxStacked() {
    var _ref2;
    var _temp, _this, _ret;
    _classCallCheck(this, CheckboxStacked);
    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref2 = CheckboxStacked.__proto__ || Object.getPrototypeOf(CheckboxStacked)).call.apply(_ref2, [this].concat(args))), _this), _this.renderBoxes = function (selected, onChange) {
      return _react2.default.createElement(Wrapper, {
        singleColumn: _this.props.singleColumn
      }, _this.props.options.map(function (option) {
        var value = typeof option === 'string' ? option : option.value;
        var text = typeof option === 'string' ? option : option.text;
        var inputName = _this.props.name + '_' + value;
        return _react2.default.createElement(_checkbox2.default, {
          name: inputName,
          value: value,
          text: text,
          onChange: onChange,
          key: value,
          selected: selected.includes(value),
          css: _this.props.singleColumn ? {} : {
            flex: '1 0 40%',
            minWidth: '175px',
            paddingRight: '7px'
          }
        });
      }));
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }
  _createClass(CheckboxStacked, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_checkboxWrapper2.default, Object.assign({}, this.props, {
        render: this.renderBoxes
      }));
    }
  }]);
  return CheckboxStacked;
}(_react.Component);
CheckboxStacked.propTypes = {
  name: _propTypes.string.isRequired,
  options: _constants.optionsPropTypes.isRequired,
  singleColumn: _propTypes.bool
};
CheckboxStacked.defaultProps = {
  singleColumn: false
};
exports.default = CheckboxStacked;